import { useEffect, useRef, useState } from "react";

/** Reusable canvas-based signature pad. Emits `dataURL` (PNG base64) via onChange
 * when the user finishes a stroke. Works with mouse + touch. Used by
 * ClientEstimateDialog and MyWork (weekly receipt acceptance).
 */
export default function SignaturePad({ value = "", onChange, width = 320, height = 100, testid = "signature-pad" }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(!value);

  useEffect(() => {
    const c = canvasRef.current;
    if (!c) return;
    const ctx = c.getContext("2d");
    ctx.strokeStyle = "#0f172a";
    ctx.lineWidth = 2;
    ctx.lineCap = "round";
    if (value) {
      const img = new Image();
      img.onload = () => { ctx.drawImage(img, 0, 0, c.width, c.height); setEmpty(false); };
      img.src = value;
    }
  }, [value]);

  const pos = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const t = e.touches?.[0] || e;
    return { x: t.clientX - rect.left, y: t.clientY - rect.top };
  };
  const start = (e) => {
    drawing.current = true;
    const p = pos(e);
    const ctx = canvasRef.current.getContext("2d");
    ctx.beginPath(); ctx.moveTo(p.x, p.y);
    e.preventDefault();
  };
  const move = (e) => {
    if (!drawing.current) return;
    const p = pos(e);
    const ctx = canvasRef.current.getContext("2d");
    ctx.lineTo(p.x, p.y); ctx.stroke();
    setEmpty(false); e.preventDefault();
  };
  const end = () => {
    if (!drawing.current) return;
    drawing.current = false;
    const c = canvasRef.current;
    if (c) onChange?.(c.toDataURL("image/png"));
  };
  const clear = () => {
    const c = canvasRef.current;
    if (!c) return;
    c.getContext("2d").clearRect(0, 0, c.width, c.height);
    setEmpty(true); onChange?.("");
  };

  return (
    <div>
      <canvas ref={canvasRef} width={width} height={height}
        className="w-full bg-slate-100 rounded border border-slate-200 touch-none cursor-crosshair"
        style={{ height: `${height}px` }}
        onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
        onTouchStart={start} onTouchMove={move} onTouchEnd={end}
        data-testid={testid} />
      <div className="flex justify-between items-center mt-1">
        <span className="text-[10px] text-slate-500">{empty ? "Firma con el mouse o dedo" : "✓ Firmado"}</span>
        <button type="button" onClick={clear} className="text-[10px] text-slate-400 hover:text-rose-600 underline"
          data-testid={`${testid}-clear`}>Limpiar</button>
      </div>
    </div>
  );
}
